import React,{useState} from 'react';
import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import Box from '@mui/material/Box';
import { styled } from '@mui/material/styles';
import Header from '../components/Header';
import Hero from '../components/Hero';
import Hero2 from '../components/Hero2';
import HowItWorks from '../components/HowItWorks';
import Menu from '../components/Menu';
import Footer from '../components/Footer';
import { Helmet } from 'react-helmet-async';
import Header2 from "../components/Common/Header";

const Item = styled(Paper)(({ theme }) => ({
  ...theme.typography.body2,
  padding: theme.spacing(0),
  textAlign: 'center',
  color: theme.palette.text.transparent,
  boxShadow: "none"
}));

const restaurantData = {
  "@context": "https://schema.org",
  "@type": "Restaurant",
  "name": "Nostalgia Kitchen",
  "address": {
    "@type": "PostalAddress",
    "streetAddress": "773 Warden Ave. Unit 1A",
    "addressLocality": "Scarborough",
    "addressRegion": "ON",
    "postalCode": "M1L 4C2"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.5",
    "reviewCount": "8"
  },
  "openingHours": [
    "Tu-Sun 10:00-18:00"
  ],
  "priceRange": "$$",
  "servesCuisine": ["Goan Cuisine", "Indian Cuisine"],
  "telephone": "(416) 792-7060",
  "url": "https://nostalgiakitchen.ca",
  "hasMenu": "https://nostalgiakitchen.ca/menu",
  "areaServed": ["Toronto", "Scarborough", "Mississauga", "Pickering", "Milton", "Brampton"],
  "brand": "Nostalgia Kitchen"
};

const HomePage = () => {

  return (
    <>
      <Helmet>
        <title>Nostalgia Kitchen - Taste of Goa</title>
        <meta 
          name="description" 
          content="Nostalgia Kitchen & Foods is an authentic Goan restaurant in Scarborough, ON. Our menu includes delicious Goan Fish Curry, Xacuti, Xec Xec, Sorpatel, and more." 
        />
        <link rel="canonical" href="https://nostalgiakitchen.ca/" />
        <meta property="og:title" content="Nostalgia Kitchen - Taste of Goa"/>
        <meta property="og:type" content="website"/>
        <meta property="og:url" content="https://nostalgiakitchen.ca/"/>
        <script type="application/ld+json">
          {JSON.stringify(restaurantData)}
        </script>
      </Helmet>   

      <Box sx={{ width: '100%', backgroundColor: "#F1F3E6" }}> 
        <Grid container rowSpacing={0}>
          <Grid item xs={12} sx={{ backgroundColor: "#FFB81C" }}>
            <Item sx={{ flexGrow: 1, display: { xs: 'none', md: 'block' } }}>
              <Header2 />
            </Item>
            <Item sx={{ flexGrow: 1, display: { xs: 'flex', md: 'none' } }}>
              <Header />
            </Item>
          </Grid>

          {/* Desktop Hero */}
          <Grid item xs={12} sx={{ display: { xs: "none", lg: "block" } }}>
            <Item>
              <Hero2 /> 
            </Item>
          </Grid>
       
          {/* Mobile Hero */}
          <Grid item xs={12} sx={{ display: { xs: "block", lg: "none" } }}>
            <Item>
              <Hero />
            </Item>
          </Grid>

          {/* How It Works Section */}
          <Grid item xs={12}>
            <Item>
              <HowItWorks />
            </Item>
          </Grid>
        </Grid> 

        <Menu />
        <Footer />
      </Box>
    </>
  );
};

export default HomePage;